import {
  signInWithEmailAndPassword as authSignInWithEmailAndPassword,
  signOut as authSignOut,
  getIdToken as authGetIdToken,
  onAuthStateChanged as authOnAuthStateChanged,
} from "@firebase/auth";
import { auth } from '@/lib/firebase/initial';
import type { User, NextFn, NextOrObserver } from "@firebase/auth";
import { mapOptional } from "@/utils";
import { FirebaseError } from "@firebase/util";
import { AxiosError } from "axios";


let user: User | null;

export async function signInWithEmailAndPassword(
  email: string,
  password: string
) {
  const result = await authSignInWithEmailAndPassword(
    auth,
    email,
    password
  );

  user = result.user;

  return result;
}

export function signOut() {
  localStorage.removeItem("branchId");
  localStorage.removeItem("userId");
  return authSignOut(auth);
}

export function getIdToken() {
  return mapOptional(user, authGetIdToken);
}

export function onAuthStateChanged(next: NextOrObserver<User | null>) {
  return authOnAuthStateChanged(auth, (u) => {
    user = u;

    (next as NextFn<User | null>)(u);
  });
}

export function isFirebaseError(error: unknown): error is FirebaseError {
  return (error as FirebaseError).name === "FirebaseError";
}

export function isAxiosError(error: unknown): error is AxiosError {
  return (error as AxiosError).name === "AxiosError";
}
